export function isSupportedTimeZone(timeZone: string): boolean {
	try {
		new Intl.DateTimeFormat("en", { timeZone })
		return true
	} catch {
		return false
	}
}

export function getBrowserTimeZone(): string | null {
	const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
	return timeZone && isSupportedTimeZone(timeZone) ? timeZone : null
}
